export default __webpack_public_path__ + "static/media/logo.8c444bd9.png";